import type { LucideIcon } from "lucide-react";
import { FileText, Search, Send, CheckCircle } from "lucide-react";

export type ProcessStep = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export const processSteps: ProcessStep[] = [
  {
    icon: FileText,
    title: "Análise Inicial",
    description:
      "Entendemos o seu caso, avaliamos os documentos e verificamos se estão adequados perante a legislação brasileira.",
  },
  {
    icon: Search,
    title: "Preparação Documental",
    description:
      "Organizamos toda a documentação, traduções juramentadas e apostilamento necessário.",
  },
  {
    icon: Send,
    title: "Protocolo no STJ",
    description:
      "Protocolamos seu pedido no Superior Tribunal de Justiça com fundamentação técnica completa.",
  },
  {
    icon: CheckCircle,
    title: "Reconhecimento",
    description:
      "Acompanhamos o cliente em todas as fases do processo até a decisão final.",
  },
];

